<template>
    <div class="loader">
        <i class="far fa-atom fa-2x fa-spin"></i>
    </div>
</template>

<script>
export default {
    name: 'loader'
}
</script>

<style scoped>

/* Absolute Center Spinner */
.loader {
    position: fixed;
    z-index: 999;
    height: 2em;
    width: 2em;
    overflow: visible;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    color: #4169e1;
}

</style>
